import { ReduxFormField } from "components/molecules/ReduxFormFields";
import SelectSearchZone from "components/organisms/SelectSearchZone";	
import SelectSearchDriver from "components/organisms/SelectSearchDriver";
import SelectSearchDriverGroupAddress from "components/organisms/SelectSearchDriverGroupAddress";
import SelectSearchPartner from "components/organisms/SelectSearchPartner";

export { default } from "./CalendarFilters";

export const fields: ReduxFormField[] = [
	{
		name: "zone",
		label: "Zone",
		component: SelectSearchZone,
		cellProps: { sm: 6, md: 3 },
		ComboBoxProps: {
			multiple: true,
			options: []
		}
	},
	{
		name: "drivers",
		label: "Drivers",
		component: SelectSearchDriver,
		cellProps: { sm: 6, md: 3 },
		ComboBoxProps: {
			multiple: true,
			options: []
		}
	},
	{
		name: "partner_id",
		label: "Partner",
		component: SelectSearchPartner,
		cellProps: { sm: 6, md: 3 },
		ComboBoxProps: {
			multiple: false,
			options: []
		}
	},
	{
		name: "address",
		label: "Address",
		component: SelectSearchDriverGroupAddress,
		cellProps: { sm: 6, md: 3 },
		ComboBoxProps: {
			multiple: true,
			options: []
		}
	}
]; 